import { $axios, apiList } from '@/api'

export default {
    actions: {
        getForumByCourse(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.getForumsByCourse.method,
                    params: {
                        wsfunction: apiList.forum.getForumsByCourse.moodle_method,
                        courseids: [payload]
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        checkCanUserAddDiscussion(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.canUserAddDiscussion.method,
                    params: {
                        wsfunction: apiList.forum.canUserAddDiscussion.moodle_method,
                        forumid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        getForumDiscussions(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.getForumDiscussions.method,
                    params: {
                        wsfunction: apiList.forum.getForumDiscussions.moodle_method,
                        forumid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        createForumDiscussions(_, {id, subject, message}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.createDiscussion.method,
                    params: {
                        wsfunction: apiList.forum.createDiscussion.moodle_method,
                    },
                    data: {
                        forumid: id,
                        subject: subject,
                        message: message
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        getDiscussionPosts(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.getDiscussionPosts.method,
                    params: {
                        wsfunction: apiList.forum.getDiscussionPosts.moodle_method,
                        discussionid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        createPost(_, {postid, subject, message}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.createPost.method,
                    params: {
                        wsfunction: apiList.forum.createPost.moodle_method
                    },
                    data: {
                        postid,
                        subject,
                        message
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        deletePost(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.deletePost.method,
                    params: {
                        wsfunction: apiList.forum.deletePost.moodle_method,
                    },
                    data: {
                        postid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        updatePost(_, {postid, subject, message}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.updatePost.method,
                    params: {
                        wsfunction: apiList.forum.updatePost.moodle_method,
                    },
                    data: {
                        postid,
                        subject,
                        message
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        viewForum(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.viewForum.method,
                    params: {
                        wsfunction: apiList.forum.viewForum.moodle_method,
                    },
                    data: {
                        forumid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        viewDiscussion(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.viewDiscussion.method,
                    params: {
                        wsfunction: apiList.forum.viewDiscussion.moodle_method,
                    },
                    data: {
                        discussionid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        toggleDiscussFavourite(_, {discussionid, targetstate}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.toggleDiscussFavourite.method,
                    params: {
                        wsfunction: apiList.forum.toggleDiscussFavourite.moodle_method,
                    },
                    data: {
                        discussionid,
                        targetstate
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        setDiscussSubscription(_, {forumid, discussionid, targetstate}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.setDiscussionSubState.method,
                    params: {
                        wsfunction: apiList.forum.setDiscussionSubState.moodle_method,
                    },
                    data: {
                        forumid: forumid,
                        discussionid: discussionid,
                        targetstate: targetstate
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        setDiscussLockState(_, {forumid, discussionid, targetstate}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.setDiscussionLockState.method,
                    params: {
                        wsfunction: apiList.forum.setDiscussionLockState.moodle_method,
                    },
                    data: {
                        forumid: forumid,
                        discussionid: discussionid,
                        targetstate: targetstate
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        },
        setDiscussPinState(_, {discussionid, targetstate}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.forum.setDiscussionPinState.method,
                    params: {
                        wsfunction: apiList.forum.setDiscussionPinState.moodle_method,
                    },
                    data: {
                        discussionid: discussionid,
                        targetstate: targetstate
                    }
                })
                    .then(resp => {
                        resolve(resp)
                    }).catch(err => reject(err))
            })
        }
    }
}
